import { TopBar, ActionList, Icon, Frame, Text, HorizontalStack, Avatar, Navigation, Box, Image, VerticalStack } from '@shopify/polaris';
import { ArrowLeftMinor, HomeMinor, InfoMinor, ProfileMinor, QuestionMarkMajor } from '@shopify/polaris-icons';
import { useState, useCallback } from 'react';
import { auth } from '../firebase';
import { usePartnerUp } from '../providers/PartnerUpProvider';
import { getBestAvatar } from '../utils';

export function NewTopBar({ children, profile, setSelectedProfile, profiles }) {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isSecondaryMenuOpen, setIsSecondaryMenuOpen] = useState(false);

  const toggleIsUserMenuOpen = useCallback(
    () => setIsUserMenuOpen((isUserMenuOpen) => !isUserMenuOpen),
    [],
  );

  const toggleIsSecondaryMenuOpen = useCallback(
    () => setIsSecondaryMenuOpen((isSecondaryMenuOpen) => !isSecondaryMenuOpen),
    [],
  );

  const handleNavigationToggle = useCallback(() => {
  }, []);
  const hasFullLogo = Boolean(profile?.storeData?.logo)
  const logo = {
    topBarSource: profile?.storeData?.logo || profile?.storeData?.squareLogo,
    width: hasFullLogo ? 200 : 45,
    url: '#',
    accessibilityLabel: 'Shopify',
  };

  let topBarItems = [];

  /*
  topBarItems = topBarItems.concat(profiles?.map((p, i) => ({
    content: (
      <Box onClick={() => setSelectedProfile(i)}>
        <HorizontalStack gap="2">
          {
            p.storeData?.name
          }
          <Avatar size="small" shape="square" source={p.storeData?.squareLogo} />
        </HorizontalStack>
      </Box>
    )
  })))
  */

  const userMenuMarkup = (
    <TopBar.UserMenu
      actions={[
        {
          items: topBarItems,
        },
        {
          items: [{
            content: (
              <HorizontalStack gap="2">
                Sign Out
              </HorizontalStack>
            ), onAction: async () => {
              await auth.signOut()
              window.location.reload();
            }
          }],
        },
      ]}
      name={
        <VerticalStack>
          <Text>
            {
              profile?.name
            }
          </Text>
          <Text color="subdued">
            {profile?.email}
          </Text>
        </VerticalStack>
      } // profile?.storeData?.name}
      avatar={getBestAvatar(profile)} // profile?.storeData?.squareLogo}
      open={isUserMenuOpen}
      onToggle={toggleIsUserMenuOpen}
    />
  );

  const secondaryMenuMarkup = (
    <TopBar.Menu
      activatorContent={
        <span>
          <Icon source={QuestionMarkMajor} />
          <Text as="span" visuallyHidden>
            Secondary menu
          </Text>
        </span>
      }
      open={isSecondaryMenuOpen}
      onOpen={toggleIsSecondaryMenuOpen}
      onClose={toggleIsSecondaryMenuOpen}
      actions={[
        {
          items: [{ content: 'support@partnerup.net' }],
        },
      ]}
    />
  );

  const navigationMarkup = (
    <Navigation location="/">
      <Navigation.Section
        items={[
          {
            label: 'Home',
            icon: HomeMinor,
            selected: window.location.pathname === '/',
            onClick: () => {
              navigate('/')
            }
          },
          {
            excludePaths: ['#'],
            label: 'Earnings',
            icon: InfoMinor,
            selected: window.location.pathname === '/earnings',
            onClick: () => {
              navigate('/earnings')
            }
          },
          {
            excludePaths: ['#'],
            label: 'Profile',
            icon: ProfileMinor,
            selected: window.location.pathname === '/profile',
            onClick: () => {
              navigate('/profile')
            }
          },
          {
            excludePaths: ['#'],
            label: 'Support',
            icon: InfoMinor,
            selected: window.location.pathname === '/support',
            onClick: () => {
              navigate('/support')
            }
          },
        ]}
      />
    </Navigation>
  )

  const topBarMarkup = (
    <TopBar
      logoSuffix={!hasFullLogo ? profile?.storeData?.name : ''}
      showNavigationToggle
      userMenu={userMenuMarkup}
      secondaryMenu={secondaryMenuMarkup}
      // searchResultsVisible={isSearchActive}
      // searchField={searchFieldMarkup}
      // searchResults={searchResultsMarkup}
      // onSearchResultsDismiss={handleSearchResultsDismiss}
      onNavigationToggle={handleNavigationToggle}
    />
  );

  return (
    <div style={{ height: '250px' }}>
      <Frame topBar={topBarMarkup} logo={<Image source={logo} height="100%" />}
      // navigation={navigationMarkup}
      >
        {children}
      </Frame>
    </div>
  );
}
